export const allCompaniesID = -1;
